// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section__AboutSection-module--UhCn8 {
    padding: var(--space-3xl) var(--space-md) var(--space-xl);
    scroll-margin-top: 80px;
}

.inner__AboutSection-module--Gom5B {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(340px, 100%), 1fr));
    gap: var(--space-2xl);
}

.heading__AboutSection-module--ZokgG {
    margin: 0;
    align-self: start;
    position: sticky;
    top: 96px;
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
}

.copy__AboutSection-module--tGIEW {
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    max-width: 640px;
}

.copy__AboutSection-module--tGIEW p {
    margin: 0;
}

.lead__AboutSection-module--J1WTu {
    font-size: clamp(20px, 2vw, 24px);
    line-height: 1.45;
    font-weight: 500;
    letter-spacing: -0.01em;
}

.paragraph__AboutSection-module--MjJ0c {
    font-size: 17px;
    line-height: 1.65;
    color: var(--color-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/AboutSection.module.css"],"names":[],"mappings":"AAAA;IACI,yDAAyD;IACzD,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sEAAsE;IACtE,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kCAAkC;AACtC","sourcesContent":[".section {\n    padding: var(--space-3xl) var(--space-md) var(--space-xl);\n    scroll-margin-top: 80px;\n}\n\n.inner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(340px, 100%), 1fr));\n    gap: var(--space-2xl);\n}\n\n.heading {\n    margin: 0;\n    align-self: start;\n    position: sticky;\n    top: 96px;\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n}\n\n.copy {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    max-width: 640px;\n}\n\n.copy p {\n    margin: 0;\n}\n\n.lead {\n    font-size: clamp(20px, 2vw, 24px);\n    line-height: 1.45;\n    font-weight: 500;\n    letter-spacing: -0.01em;\n}\n\n.paragraph {\n    font-size: 17px;\n    line-height: 1.65;\n    color: var(--color-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `section__AboutSection-module--UhCn8`,
	"inner": `inner__AboutSection-module--Gom5B`,
	"heading": `heading__AboutSection-module--ZokgG`,
	"copy": `copy__AboutSection-module--tGIEW`,
	"lead": `lead__AboutSection-module--J1WTu`,
	"paragraph": `paragraph__AboutSection-module--MjJ0c`
};
export default ___CSS_LOADER_EXPORT___;
